"use client";
import React, { useState } from "react";
import { motion } from "framer-motion";
import { BenefitsSection } from "./BenifitSection";

export const HeroSection: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [terms, setTerms] = useState(false);
  const [updates, setUpdates] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Redirect to app signup page
    window.location.href = "https://app.vawena.ai/signup";
  };

  // OAuth handlers
  const handleOAuthSignup = (provider: 'google' | 'microsoft' | 'apple') => {
    // Redirect to app for OAuth signup
    window.location.href = `https://app.vawena.ai/login?provider=${provider}`;
  };

  const steps = [
    {
      title: "Email Verification",
      desc: "Quick email confirmation to secure your account",
      icon: "/assets/images/auth/icons/Group.png",
    },
    {
      title: "Platform Exploration",
            // desc: "All seven modules available immediately",

      desc: "Wealth Scope and Portfolio IQ available immediately",
      icon: "/assets/images/auth/icons/Icon 2.png",
    },
    {
      title: "Portfolio Setup",
      desc: "AI-assisted setup with intelligent recommendations",
      icon: "/assets/images/auth/icons/Group (1).png",
    },
    {
      title: "Feature Discovery",
      desc: "Premium features highlighted naturally during use",
      icon: "/assets/images/auth/icons/Group (2).png",
    },
    {
      title: "Upgrade When Ready",
      desc: "Individual feature upgrades as your portfolio grows",
      icon: "/assets/images/auth/icons/Icon 5.png",
    },
  ];

  return (
    <section className="self-center mt-16 w-full max-w-[1309px] px-2 max-md:mt-10">
      <div className="flex gap-8 max-md:flex-col">
        {/* LEFT FORM SECTION */}
        <motion.div
          className="w-[42%] max-md:w-full"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <form
            onSubmit={handleSubmit}
            className="flex flex-col text-base text-white"
          >
            <h1 className="text-xl md:text-2xl font-extrabold leading-tight">
              Experience Investment Through Intelligence
            </h1>
            <p className="mt-3 leading-6 text-white/95 text-sm md:text-base">
              Join the intelligent investing revolution - start completely free
              and upgrade features as your portfolio grows
            </p>

            {/* Email */}
            <label htmlFor="email" className="mt-6">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter the email address"
              className="px-4 py-4 md:px-6 md:py-6 mt-3.5 text-white rounded-xl bg-transparent border border-gray-600 focus:ring-2 focus:ring-blue-500 outline-none transition"
            />

            {/* Password */}
            <label htmlFor="password" className="mt-5">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="*****************"
              className="px-4 py-4 md:px-6 md:py-6 mt-3.5 text-white rounded-xl bg-transparent border border-gray-600 focus:ring-2 focus:ring-blue-500 outline-none transition"
            />

            {/* Confirm Password */}
            <label htmlFor="confirmPassword" className="mt-5">
              Confirm Password
            </label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="*****************"
              className="px-4 py-4 md:px-6 md:py-6 mt-3.5 text-white rounded-xl bg-transparent border border-gray-600 focus:ring-2 focus:ring-blue-500 outline-none transition"
            />

            {/* Checkboxes */}
            <div className="flex flex-col mt-6 text-sm gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={terms}
                  onChange={(e) => setTerms(e.target.checked)}
                  className="w-5 h-5 rounded border border-slate-500"
                />
                I agree to the Terms of Service & Privacy Policy
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={updates}
                  onChange={(e) => setUpdates(e.target.checked)}
                  className="w-5 h-5 rounded border border-slate-500"
                />
                Send me updates about new features and investment insights
                (optional)
              </label>
            </div>

            {/* Submit Button */}
            <motion.button
              type="submit"
              className="px-6 py-4 md:py-6 mt-5 rounded-[59px] bg-gradient-to-r from-[#243B7D] to-[#416BE3] hover:brightness-110 transition-all"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started - Completely Free
            </motion.button>

            {/* Divider */}
            <div className="flex items-center mt-6 gap-2 text-sm md:text-base text-white">
              <div className="flex-1 h-px bg-white/40" />
              <span>or signup with</span>
              <div className="flex-1 h-px bg-white/40" />
            </div>

            {/* Social Signup */}
            <div className="flex flex-wrap gap-3 md:gap-4 mt-4 text-sm">
              {(["google", "microsoft", "apple"] as const).map((provider) => (
                <motion.button
                  key={provider}
                  onClick={() => handleOAuthSignup(provider)}
                  className="flex flex-1 items-center justify-center gap-2 px-5 py-3 rounded-xl bg-sky-900 bg-opacity-40 hover:bg-opacity-60 transition"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <img
                    src={`/assets/images/auth/${provider}.png`}
                    alt={`${provider} logo`}
                    className="w-6 h-6"
                  />
                  <span className="capitalize">via {provider}</span>
                </motion.button>
              ))}
            </div>

            <p className="mt-5 text-sm md:text-base text-white/90 text-center">
              Already have an account?{" "}
              <span 
                onClick={() => window.location.href = "https://app.vawena.ai/login"}
                className="text-white font-bold cursor-pointer hover:underline"
              >
                Login Now
              </span>
            </p>
          </form>
        </motion.div>

        {/* RIGHT IMAGE + STEPS */}
        <motion.div
          className="w-[58%] max-md:w-full"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <motion.img
            src="/assets/images/auth/container-3.png"
            alt="Investment platform preview"
            className="w-full object-contain aspect-[2.21] max-md:mt-10 rounded-lg"
            whileHover={{ scale: 1.02 }}
          />

          <section className="flex flex-col mt-10">
            <h3 className="self-center mb-6 text-lg font-bold text-white underline">
              Next Steps Preview
            </h3>

            {/* ICONS */}
            <div className="flex justify-between items-center w-full max-w-4xl mx-auto px-2 sm:px-4">
              {steps.map((step, idx) => (
                <motion.img
                  key={idx}
                  src={step.icon}
                  alt={step.title}
                  className="w-10 h-10 sm:w-[52px] sm:h-[52px] cursor-pointer"
                  whileHover={{ scale: 1.15, rotate: 5 }}
                  whileTap={{ scale: 0.95 }}
                />
              ))}
            </div>

            {/* Flow line */}
            <motion.img
              src="https://api.builder.io/api/v1/image/assets/2786a9b4d60a41fc839971aa8ed25ba5/f27cee6a-eb20-4022-a346-f34cceaf0839?placeholderIfAbsent=true"
              alt="Process flow diagram"
              className="mt-3 w-full max-w-4xl mx-auto"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.7 }}
            />

            {/* Steps titles */}
            <div className="grid grid-cols-2 sm:flex justify-between mt-4 w-full max-w-4xl mx-auto gap-4 sm:gap-0 px-2 sm:px-4">
              {steps.map((step, idx) => (
                <motion.div
                  key={idx}
                  className="flex flex-col items-center w-full sm:w-[120px] p-2 rounded-xl hover:bg-white/5 transition"
                  whileHover={{ scale: 1.05 }}
                >
                  <h4 className="text-xs sm:text-sm font-semibold text-white text-center">
                    {step.title}
                  </h4>
                  <p className="mt-1 text-[10px] sm:text-xs text-stone-50 text-center">
                    {step.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </section>

          <BenefitsSection />
        </motion.div>
      </div>
    </section>
  );
};
